define([
    'model/Error',
    'model/ErrorType',
    'service/FileService',
    'factory/CloudIdentityFactory',
    'amdi18n-loader?!state/nls/IdentityCreationState_strings'
    ],
    function (
            Error,
            ErrorType,
            FileService,
            CloudIdentityFactory,
            Strings
            ) {
	'use strict';

	var _sessionStorageData = null,
		_localStorageData = null;


	// private methods

	function check() {
		if (_localStorageData === null || _sessionStorageData === null) {
			readData();
		}
	}

	function readData() {
		var sessionStorageData = sessionStorage.getItem('skIdS_data'),
			localStorageData = localStorage.getItem('skIdS_data');

		if (localStorageData !== null && localStorageData !== "") {
			localStorageData = JSON.parse(localStorageData);
		} else {
			localStorageData = new Object();
		}

		if (sessionStorageData !== null) {
			sessionStorageData = JSON.parse(sessionStorageData);
		} else {
			sessionStorageData = new Object();
		}

		_sessionStorageData = sessionStorageData;
		_localStorageData = localStorageData;
	}


	// public methods

	function store(key, value, sessionOnly) {
		check();

		try {
			if (typeof sessionOnly === 'boolean' && sessionOnly) {
				_sessionStorageData[key] = value;

				sessionStorage.setItem('skIdS_data', JSON.stringify(_sessionStorageData));
			} else {
				_localStorageData[key] = value;

				localStorage.setItem('skIdS_data', JSON.stringify(_localStorageData));
			}
		} catch (domException) {
			if (domException.name === 'QuotaExceededError' ||
					domException.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
				// handle exception
			}
		}
}

	function read(key, forceReload) {
                if (typeof forceReload === 'boolean' && forceReload) {
                    _sessionStorageData = null;
                    _localStorageData = null;
                }
		check();

		if (_localStorageData.hasOwnProperty(key)) {
			return _localStorageData[key];
		} else if (_sessionStorageData.hasOwnProperty(key)) {
			return _sessionStorageData[key];
		}

		return null;
	}

	function remove(key) {
		check();

		if (_localStorageData.hasOwnProperty(key)) {
			delete _localStorageData[key];

			localStorage.setItem('skIdS_data', JSON.stringify(_localStorageData));
		} else if (_sessionStorageData.hasOwnProperty(key)) {
			delete _sessionStorageData[key];

			sessionStorage.setItem('skIdS_data', JSON.stringify(_sessionStorageData));
		}
	}
        
        function importCloudIdentity(_uiStateManager, errorcallback) {
			FileService.upload(function (data) {
				try {
                                        var id = CloudIdentityFactory.createFromObject(JSON.parse(data));
                                        _uiStateManager.core().cloudIdentitiesManager().addCloudIdentity(id);
					_uiStateManager.change('identities_overview');
				} catch (error) {
					errorcallback(new Error(ErrorType.RECOVERABLE, Strings.invalid_identity_specified));
//					_uiStateManager.change('error', {
//						error : new Error(ErrorType.RECOVERABLE, Strings.invalid_identity_specified),
//						nextCallback : function () {
//							_uiStateManager.change('identity_creation');
//						}
//					});
				}
			}, function (error) {
				_uiStateManager.change('error', {
					error : error,
					nextCallback : function () {
						_uiStateManager.change('identity_creation');
					}
				});
			});
		}

	return {
		store : store,
		read : read,
		remove : remove,
                importCloudIdentity : importCloudIdentity
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/StorageUtil.js
// module id = 19
// module chunks = 6